import Modal, { OwnProps as ModalProps } from 'components/Shared/Modal/index';
import { CheckoutBlock } from 'views/CheckoutPage/checkoutBlock';
import styles from './styles.scss';
import cn from 'classnames';
import { rm } from 'utils';
import Button from 'components/Shared/Button';
import { IconArrow } from 'components/Shared/Icon';

export const CheckoutModal = (props: ModalProps) => (
  <Modal {...props} contentClassName={cn(styles.checkoutModal, props.contentClassName)}>
    <ModalContent>{props.children}</ModalContent>
  </Modal>
);

export const ModalBlock = (props: { children: React.ReactNode }) => (
  <CheckoutBlock className={styles.modalInnerBlock}>{props.children}</CheckoutBlock>
);

export const ModalContent = (props: { children: React.ReactNode }) => (
  <div className={styles.modalContent}>{props.children}</div>
);

interface CheckoutConfirmModalProps extends ModalProps {
  onAccept: () => void;
}
export const CheckoutConfirmModal = ({
  onAccept,
  children,
  ...props
}: CheckoutConfirmModalProps) => (
  <CheckoutModal {...props}>
    {children}
    <div className={styles.modalConfirmButtonContainer}>
      <Button onClick={onAccept}>
        {rm('checkout_modal_confirm')} <IconArrow size="small" />
      </Button>
      <Button onClick={props.onClose}>
        {rm('checkout_modal_deny')} <IconArrow size="small" />
      </Button>
    </div>
  </CheckoutModal>
);
